module.exports = __webpack_public_path__ + "img/timetable-300x300.5117215d.png";